import api from "./apiConfig";

export const REGISTER_GASTO = async (data) => {
	try {
        const formData = new FormData();
		formData.append("name", data.name);
		formData.append("propertieId", data.propertieId);
		formData.append("userId", data.userId);
		formData.append("subtotal", data.subtotal);
		formData.append("iva", data.iva);
		formData.append("titular", data.titular);
		formData.append("forma_pago", data.forma_pago);
		formData.append("date", data.date);
		formData.append("comments", data.comments);
		formData.append("amount", data.amount);
		formData.append("file", data.file);

        const response = await api.post("/expenses", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_GASTOS = async (id, data) => {
	try {
		const formData = new FormData();

		formData.append("file", data.file);

		const response = await api.put(`/expenses/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return response.data;
	} catch (error) {
		console.error("Error al actualizar el gasto:", error);
		throw error;
	}
};

export const GET_GASTOS = async () => {
	try {
		const response = await api.get("/expenses");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los gastos:", error);
		throw error;
	}
};

export const DELETE_GASTO = async (id) => {
	try {
		const response = await api.delete(`/expenses/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};